import {Component, OnInit} from '@angular/core';

import {BreadcrumbFileSharingOnboardingFiles, BreadcrumbMain, DocumentType, FileExplorerDisplay, SolMgrFileType, Transaction,} from '@app/shared';
import {MenuItem} from "primeng/api";

@Component({
  selector: 'app-onboarding-files',
  templateUrl: './onboarding-files.component.html',
  styleUrls: ['./onboarding-files.component.css']
})
export class OnboardingFilesComponent implements OnInit {

  FileExplorerDisplay: typeof FileExplorerDisplay = FileExplorerDisplay;
  TxnType: typeof Transaction = Transaction;
  documentType: DocumentType = DocumentType.Other;
  solMgrFileType: SolMgrFileType = SolMgrFileType.Onboard;
  showFileExplorer: boolean = true;

  breadcrumb: MenuItem[] = [];                        // main and solution mgr breadcrumb

  constructor() {
  }

  ngOnInit() {
    this.breadcrumb = [];
    this.breadcrumb.push(BreadcrumbMain);
    this.breadcrumb.push(BreadcrumbFileSharingOnboardingFiles);
  }

  updateVisibility(): void {
    /*@desc: timer is set to refresh the visibility of the table  */

    this.showFileExplorer = false;
    setTimeout(() => this.showFileExplorer = true, 5);
  }

}
